export default {
  cbam_news: "Noticias CBAM",
  view_all_news: "Ver todas las noticias",
  search_news: "Buscar noticias...",
  no_news: "No hay noticias disponibles",
  fetch_news_failed: "Error al obtener las noticias",
};
